import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, FreeMode } from "swiper/modules";  
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/free-mode";

const OurClients = () => {
  const clients = [
    "images/client-logo-1.svg",
    "images/client-logo-2.svg",
    "images/client-logo-3.svg",
    "images/client-logo-4.svg",
    "images/client-logo-1.svg",
    "images/client-logo-3.svg",
    "images/client-logo-4.svg",
    "images/client-logo-1.svg",
  ];

  return (
    <div className="our-clients">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="our-clients-box">
              <div className="section-title">
                <h3 className="wow fadeInUp">our clients</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  Transforming 1,000+ spaces with tailored designs
                </h2>
                <p className="wow fadeInUp" data-wow-delay="0.2s">
                  We've had the privilege of designing and transforming over a
                  thousand interiors, creating spaces that truly resonate with
                  our clients' visions and needs. Our approach focuses on
                  blending aesthetics and functionality, ensuring each project
                  brings comfort, elegance, and a personalized touch.
                </p>
              </div>

              <div className="our-client-slider">
                <Swiper
                  modules={[Autoplay, Pagination, FreeMode]} // ✅ Correct modules
                  slidesPerView={5}
                  spaceBetween={30}
                  loop={true} // ✅ Loop works via prop, not as a module
                  freeMode={true}
                  autoplay={{
                    delay: 1500,
                    disableOnInteraction: false,
                  }}
                  breakpoints={{
                    0: { slidesPerView: 2 },
                    576: { slidesPerView: 3 },
                    992: { slidesPerView: 5 },
                  }}
                >
                  {clients.map((logo, index) => (
                    <SwiperSlide key={index}>
                      <div className="client-logo">
                        <img src={logo} alt={`Client ${index + 1}`} />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurClients;
